import { withStyles } from "@mui/styles";
import { Typography } from "@mui/material";

export const PageTitleTypography = withStyles((theme) => {
  return {
    root: {
      fontFamily: "Open Sans !important",
      fontSize: `24px !important`,
      color: "#202124",
    },
  };
})(Typography);

export const SubTitleTypography = withStyles((theme) => {
  return {
    root: {
      fontFamily: "Roboto-Regular!important",
      fontSize: `13px !important`,
      color: "#5f6368",
    },
  };
})(Typography);

export const ControlTitleTypography = withStyles((theme) => {
  return {
    root: {
      fontFamily: "Roboto-Medium!important",
      fontSize: `13px !important`,
      color: "#202124",
      paddingBottom: "12px",
    },
  };
})(Typography);

export const SliderDimensionTypography = withStyles((theme) => {
  return {
    root: {
      fontFamily: "Roboto-Regular!important",
      fontSize: `13px !important`,
      color: "#5f6368",
    },
  };
})(Typography);

export const LinkTypography = withStyles((theme) => {
  return {
    root: {
      fontFamily: "Open Sans !important",
      fontSize: `14px !important`,
      color: "#1A73E8",
    },
  };
})(Typography);

export const ResGroupTypography = withStyles((theme) => {
  return {
    root: {
      fontFamily: "Roboto-Medium!important",
      fontSize: `13px !important`,
      color: "#202124",
      paddingTop: "24px",
    },
  };
})(Typography);

export const ResGroupTitleTypography = withStyles((theme) => {
  return {
    root: {
      fontFamily: "Roboto-Medium!important",
      fontSize: `13px !important`,
      color: "#202124",
    },
  };
})(Typography);

export const ResTitleTypography = withStyles((theme) => {
  return {
    root: {
      fontFamily: "Open Sans !important",
      fontSize: `20px !important`,
      color: "#202124",
    },
  };
})(Typography);

export const ResTextTypography = withStyles((theme) => {
  return {
    root: {
      fontFamily: "Open Sans !important",
      fontSize: `14px !important`,
      color: "#202124",
      paddingBottom: "12px",
    },
  };
})(Typography);

export const ResNoteTypography = withStyles((theme) => {
  return {
    root: {
      fontFamily: "Roboto-regular !important",
      fontSize: `13px !important`,
      color: "#5f6368",
    },
  };
})(Typography);

export const ResTableNameTypography = withStyles((theme) => {
  return {
    root: {
      fontFamily: "Roboto-regular !important",
      fontSize: `13px !important`,
      color: "#5f6368",
    },
  };
})(Typography);

export const ResTableValueTypography = withStyles((theme) => {
  return {
    root: {
      fontFamily: "Roboto-regular !important",
      fontSize: `14px !important`,
      color: "#202124",
    },
  };
})(Typography);
